import './services.css';

const CATEGORIES = [
  {
    id: 'highlights',
    index: '01',
    label: "Highlights",
    items: [
      { name: "Face Frame Foil", price: "$65+" },
      { name: "Partial Foil", price: "$140+" },
      { name: "Full Foil", price: "$190+" },
      { name: "Mini Foil", price: "$45", addon: true },
    ],
  },
  {
    id: 'style',
    index: '02',
    label: "Style",
    items: [
      { name: "Blowout", price: "$50" },
      
      { name: "Haircut Standalone", price: "$50" },
      { name: "Haircut W/ Color", price: "$45", addon: true },
      { name: "Keratin Express", price: "$150" },
      { name: "Keratin Smoothing", price: "$375" },
    ],
  },
  {
    id: 'color',
    index: '03',
    label: "Color",
    items: [
      { name: "Base Color", price: "$90" },
      { name: "All Over Color", price: "$120+" },
      { name: "All Over Gloss", price: "90+" },
    ],
  },
  
  {
    id: 'addons',
    index: '04',
    label: "Add-Ons",
    items: [
      { name: "Gloss W/ Highlight", price: "$25", addon: true },
      { name: "Additional Product", price: "$10", addon: true },
    ],
  },
];

export default function Services() {
  return (
    <section className="services" id="services">

      {/* Header */}
      <div className="services-header" data-aos="fade-up">
        <div className="services-header-left">
          <div className="services-eyebrow">
            <span className="services-eyebrow-dot" />
            <span>Services</span>
          </div>
          <h2 className="services-title">
            What's<br /><em>Offered</em>
          </h2>
        </div>
        <div className="services-header-right">
          <p className="services-disclaimer">
            All color services include 2oz color, gloss, metal detox,
            K18 Peptide Repair Mask, scalp massage &amp; style
          </p>
        </div>
      </div>

      {/* Rule */}
      <div className="services-full-rule" />

      {/* Categories */}
      <div className="services-categories">
        {CATEGORIES.map((cat, ci) => (
          <div
            className="services-category"
            key={cat.id}
            data-aos="fade-up"
            data-aos-delay={ci * 80}
          >
            <div className="category-head">
              <div className="category-meta">
                <span className="category-index">{cat.index}</span>
                <span className="category-dash">—</span>
                <span className="category-label">{cat.label}</span>
              </div>
              <div className="category-rule" />
            </div>

            <ul className="category-items">
              {cat.items.map((item) => (
                <li className="service-row" key={item.name}>
                  <span className="service-name">
                    {item.name}
                    {item.addon && (
                      <span className="addon-badge" aria-label="add-on service">
                        <svg width="7" height="7" viewBox="0 0 8 8" fill="none" aria-hidden="true">
                          <path d="M4 1v6M1 4h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                        Add-On
                      </span>
                    )}
                  </span>
                  <span className="service-dots" aria-hidden="true" />
                  <span className="service-price">{item.price}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

    </section>
  );
}
